// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e00f2378","953":"f9e9cfcf"}[chunkId] + ".chunk.js";
};